import React, { useState, useRef, useEffect } from "react";
import { Search, User, Bell, Settings, LogOut } from "lucide-react";
import { useNavigate } from "react-router-dom";

const Header: React.FC = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const userRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();

  // Close dropdown if clicked outside
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (userRef.current && !userRef.current.contains(event.target as Node)) {
        setMenuOpen(false);
      }
    }
    if (menuOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [menuOpen]);

  const handleSignOut = () => {
    // Implement sign out logic here if needed
    navigate("/");
  };

  return (
    <div className="bg-transparent bg-opacity-95 p-6">
      <div className="flex justify-end items-center gap-4">
        {/* <div className="relative">
          <Search
            className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"
            size={16}
          />
          <input
            type="text"
            placeholder="Search here..."
            className="pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          />
        </div> */}
        <div className="relative px-4" ref={userRef}>
          <div
            className="flex items-center gap-2 text-white cursor-pointer select-none"
            onClick={() => setMenuOpen((v) => !v)}
          >
            <User size={16} />
            <span className="text-sm font-medium">Galaxy Admin</span>
          </div>
          {menuOpen && (
            <div className="absolute right-0 mt-2 w-36 bg-white border border-gray-200 rounded-lg shadow-lg z-50">
              <button
                className="flex items-center w-full px-4 py-2 text-sm text-red-600 hover:bg-gray-100 hover:rounded-lg gap-2"
                onClick={handleSignOut}
              >
                <LogOut size={16} />
                Sign Out
              </button>
            </div>
          )}
        </div>
        {/* <Bell className="text-gray-400 cursor-pointer" size={20} />
        <Settings className="text-gray-400 cursor-pointer" size={20} /> */}
      </div>
    </div>
  );
};

export default Header;
